__turbopack_context__.v({
  "Container": "index-module-scss-module__WCz25W__Container",
  "labelOff": "index-module-scss-module__WCz25W__labelOff",
  "labelOn": "index-module-scss-module__WCz25W__labelOn",
  "left": "index-module-scss-module__WCz25W__left",
  "mobile_inner_height": "index-module-scss-module__WCz25W__mobile_inner_height",
  "mobile_style": "index-module-scss-module__WCz25W__mobile_style",
  "right": "index-module-scss-module__WCz25W__right",
  "selected": "index-module-scss-module__WCz25W__selected",
  "slider": "index-module-scss-module__WCz25W__slider",
  "switch": "index-module-scss-module__WCz25W__switch",
  "switchOff": "index-module-scss-module__WCz25W__switchOff",
  "switchOn": "index-module-scss-module__WCz25W__switchOn",
  "tabWrapper": "index-module-scss-module__WCz25W__tabWrapper",
});
